<div id="tour-dashboard-pc" class="card">
  <div class="card__title">
    {{title()}}
    @if(!hasNoProducts()){
    <a class="card__title-link" [routerLink]="gotoProductLink()">Go to Product</a>
    }

  </div>
  <div class="card__content card__content--grid">
    <div id="tour-dashboard-links" class="kpi kpi--name">
      <div class="kpi__quick">
        <div class="kpi__quick-title">Quick Links</div>

        @if(productState().hasBothProducts){
        @if(!productState().isBank){
        <a class="kpi__quick-link" (click)="navigate('/peer-comparison/balance/snapshot')">Balance Sheet</a>
        <a class="kpi__quick-link" (click)="navigate('/peer-comparison/quarterly')">Quarterly Summary</a>
        }
        <a class="kpi__quick-link" (click)="navigate('/non-maturity-deposits/decay_basic')">Balance Decay</a>
        <a class="kpi__quick-link" (click)="navigate('/non-maturity-deposits/beta_reg/beta_basic')">Beta/Regressions</a>
        }
        @else{
        @if(productState().hasPeerComparison){
        <a class="kpi__quick-link" (click)="navigate('/peer-comparison/balance/snapshot')">Balance Sheet</a>
        <a class="kpi__quick-link" (click)="navigate('/peer-comparison/quarterly')">Quarterly Summary</a>
        <a class="kpi__quick-link" (click)="navigate('/peer-comparison/correlations')">Correlations</a>
        <a class="kpi__quick-link" (click)="navigate('/peer-comparison/groups')">Peer Groups</a>
        }

        @if(productState().hasNonMaturity){
        <a class="kpi__quick-link" (click)="navigate('/non-maturity-deposits/decay_basic')">Balance Decay</a>
        <a class="kpi__quick-link" (click)="navigate('/non-maturity-deposits/beta_reg/beta_basic')">Beta/Regressions</a>
        }
        }

      </div>
    </div>
    @if(productState().isBank){
    <app-kpi-recent-institution [institution]="institution()" (click)="onClick(institution().iid)"
      metricInput="LBPRE600" titleInput="Loans to Deposits" [invertColors]="true"></app-kpi-recent-institution>
    <app-kpi-recent-institution [institution]="institution()" metricInput="ASTP3003"
      (click)="onClick(institution().iid)" titleInput="Liquid Asset Ratio"></app-kpi-recent-institution>
    <app-kpi-recent-institution [institution]="institution()" metricInput="LBPRE592" titleInput="Non-Core Funding"
      (click)="onClick(institution().iid)" [invertColors]="true"></app-kpi-recent-institution>
    <app-kpi-recent-institution [institution]="institution()" metricInput="ASTP0029"
      (click)="onClick(institution().iid)" titleInput="Cash and Dep/Assets"></app-kpi-recent-institution>
    <app-kpi-recent-institution [institution]="institution()" metricInput="DEPP0007"
      (click)="onClick(institution().iid)" titleInput="Non-Maturity to Total Deposits"></app-kpi-recent-institution>

    <div class="kpi-key-desc expand">
      Values in green with an up arrow (↑) indicate an improvement from the previous quarter. <br>
      Values in red with a down arrow (↓) indicate a decline from the previous quarter.
    </div>
    }
    @else
    {
    @for (institution of sortedInstitutions(); track institution.iid) {
    <app-kpi-recent-institution (click)="onClick(institution.iid)"
      [institution]="institution"></app-kpi-recent-institution>
    }
    }
  </div>
</div>